<!--
/**
* @name: List.vue
* @description: 交易管理-退款截图页面
* @author: 杨波
* @create: 2020/10/08 14:06:58
* @update: 2020/10/08 14:06:58
*/
-->

<template>
  <y-view>
    <div class="form-box">
      <y-form title="订单信息" id="basic" gutter="0px 30px" titleAlign="left" titleWidth="80px" contentWidth="500px">
        <y-form-item title="订单状态：">{{ orderDetailInfo.orderStatusName }}</y-form-item>
        <y-form-item title="订单号：">{{ orderDetailInfo.orderSn }}</y-form-item>
        <y-form-item title="下单时间：">{{ orderDetailInfo.createTime }}</y-form-item>
        <y-form-item title="订购人&收件人：">{{ orderDetailInfo.orderAddress.consignee }}</y-form-item>
        <y-form-item title="电话号码：">{{ orderDetailInfo.orderAddress.consigneeMobile }}</y-form-item>
        <y-form-item title="身份证：">{{ orderDetailInfo.orderAddress.buyerId }}</y-form-item>
        <y-form-item title="收货地址：">{{ orderDetailInfo.orderAddress.fullAddress }}</y-form-item>
        <y-form-item title="支付金额：">
          <span :class="css.red">{{ orderDetailInfo.orderPayment.payAmount }}</span>
        </y-form-item>
      </y-form>
      <div class="spliter"></div>
      <y-form title="退款信息" id="recive" gutter="0px 30px" titleAlign="left" titleWidth="80px" contentWidth="100%">
        <y-form-item title="申请信息：">
          <span :class="css.red">仅退款</span>
        </y-form-item>
        <y-form-item title="申请时间：">{{ orderDetailInfo.afterSaleApplyTime }}</y-form-item>
        <y-form-item title="商品信息：" align="top">
          <k-table :data="orderDetailInfo.orderGoodsList" :class="css.tableW" max-height="600px" :columns="initColumnGoods()"></k-table>
        </y-form-item>
        <y-form-item title="退款状态：">退款成功</y-form-item>
        <y-form-item title="退款金额：">{{ orderDetailInfo.orderPayment.payAmount }}</y-form-item>
        <y-form-item title="退款时间：">{{ orderDetailInfo.refundTime }}</y-form-item>
        <y-form-item title="注意事项：" required align="top">
          <p>1、售后申请审核通过后，需要寄回的商品请按客服提供的退货地址寄回；</p>
          <p>2、“巢品甄选”接受圆通等普通快递，请勿使用顺丰、平邮、货到付款等快递方式；</p>
          <p>3、退货时，请使用保护物或填充物确保商品与寄出或收到时一致，同时请在寄回的包裹中附上一下信息：订单号、收货人姓名、联系方式、退货商</p>
          <p>品、退货数量、退货原因（必须是客户拍下时留下的信息），包裹寄出后，请及时将退货运单号填写至系统中，我们收到商品后会为您尽快办</p>
          <p>理退款，请您耐心等待。</p>
        </y-form-item>
      </y-form>
    </div>
  </y-view>
</template>

<script>
import { NESTLE_TRADE_BACK_SERVER_ORDERS_DETAIL } from "@/assets/modules/apiList";

export default {
  data() {
    return {
      orderDetailInfo: {
        orderAddress: {
          consignee: "",
          consigneeMobile: "",
          orderStatusName: "",
        },
        orderPayment: {
          payName: "",
          payAmount: "",
          payTime: "",
          transactionNo: "",
        },
      },
    };
  },
  methods: {
    initColumnGoods() {
      return [
        {
          name: "退款商品名称",
          field: "goodsNameSale",
          style: {
            width: 250,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "问题数量",
          field: "quesNum",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "退款原因",
          field: "result",
          style: {
            width: 180,
            textAlign: "center",
          },
        },
        {
          name: "退款说明",
          field: "desc",
          style: {
            width: 180,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
      ];
    },
    getorderInfo(orderSn) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDERS_DETAIL,
        para: { orderSn: orderSn },
      })
        .then((res) => {
          this.orderDetailInfo = res || {};
          this.orderDetailInfo.orderPayment = res.orderPayment ? res.orderPayment : {};
          for (let i = 0; i < this.orderDetailInfo.orderGoodsList.length; i++) {
            this.orderDetailInfo.orderGoodsList[i].quesNum = 6;
            this.orderDetailInfo.orderGoodsList[i].result = "客人要求取消";
            this.orderDetailInfo.orderGoodsList[i].desc = "错拍/拍重/取消";
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    const { orderSn } = this.$route.query;
    if (orderSn) {
      this.getorderInfo(orderSn);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { orderSn } = to.query;
    if (orderSn) {
      this.getorderInfo(orderSn);
    }
    next();
  },
};
</script>

<style lang="postcss" module="css">
.red {
  color: #f00;
}
.query {
  display: flex;
  flex-direction: row;
  & > div {
    width: 100% !important;
  }
}
.query_item {
  width: 23% !important;
}
.tableW {
  width: 100%;
}
</style>
